<template>
    <span>
        <b-button
            variant="success"
            @click.stop="abrirModal()"
            class="ml-2"
            v-if="!desabilitarBotaoEnviarRequisicao"
        >
            <span>
                <i class="fa fa-paper-plane"></i>
                Enviar Solicitação
            </span>
        </b-button>

        <b-modal v-model="mostrarModal" centered>
            <div slot="modal-title">Confirmar Envio da Solicitação</div>

            <b-row>
                <b-col sm="12">
                    <p class="mb-3">
                        {{ mensagemModal }}
                    </p>

                    <b-form-group>
                        <label class="d-block">
                            <b-form-checkbox
                                v-model="confirmadoEnvio"
                                class="d-inline-block align-middle mr-2"
                            />
                            <span class="align-middle">
                                {{ mensagemConfirmacao }}
                                <span class="text-danger">*</span>
                            </span>
                        </label>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
                <b-button
                    variant="success"
                    class="ml-2"
                    :disabled="!confirmadoEnvio"
                    @click.stop="confirmarEnviarSolicitacao()"
                >
                    Enviar Solicitação
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { watch } from 'vue'
import RequisicoesServicos from './RequisicoesServicos'
export default {
    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            mostrarModal: false,
            confirmadoEnvio: false,
            desabilitarBotaoEnviarRequisicao: true,
            mensagemModal: '',
            mensagemConfirmacao: '',
            emailUsuarioAtual: this.$store.getters.usuario.email
        }
    },

    mounted() {
        this.desabilitarBotaoEnviarRequisicao = this.deveDesabilitarBotaoEnviarRequisicao()
    },

    methods: {
        abrirModal() {
            this.mensagemModal =
                this.requisicao.situacaoSolicitacao == 3
                    ? 'Você tem certeza, que deseja re-enviar a solicitação de requisição? Pois a mesma já foi devolvida para solicitação de ajustes pelo responsável UABS'
                    : 'Ao enviar a solicitação, a mesma será analisada e em breve você receberá um retorno sobre a análise.'
            this.mensagemConfirmacao =
                this.requisicao.situacaoSolicitacao == 3
                    ? 'Confirmo o re-envio da solicitação'
                    : 'Confirmo o envio da solicitação'
            this.confirmadoEnvio = false
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        confirmarEnviarSolicitacao() {
            this.enviarSolicitacaoRequisicao(this.requisicao.idRequisicao)
            this.fecharModal()
        },
        enviarSolicitacaoRequisicao(idRequisicao) {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.enviarRequisicaoSolicitacao(idRequisicao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação realizada com sucesso',
                                'SUCESSO',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                'Erro ao solicitar requisição',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                        this.$emit('atualizarRequisicao')
                    }
                })
                .catch(() => {
                    this.$toast.error(
                        'Erro na comunicação com o servidor',
                        'ERROR',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
        deveDesabilitarBotaoEnviarRequisicao() {
            if (!this.requisicao) {
                return true
            }
            if (this.requisicao.codSituacao == 2) {
                return false
            }
            const situacaoRequisicaoParaEnviar = 0
            const situacaoRequisicaoDevolvida = 3

            const requisicaoParSerEnviada =
                this.requisicao.situacaoSolicitacao ==
                situacaoRequisicaoParaEnviar
            const requisicaoDevolvida =
                this.requisicao.situacaoSolicitacao ==
                situacaoRequisicaoDevolvida
            const possuiComprometimentos =
                this.requisicao.comprometimentos &&
                this.requisicao.comprometimentos.length > 0
            const requisicaoSemSaldoASerRateado =
                this.requisicao.saldoASerRateado == 0
            const usuarioAtualSolicitante =
                this.requisicao.emailSolicitante == this.emailUsuarioAtual

            return !(
                (requisicaoParSerEnviada || requisicaoDevolvida) &&
                possuiComprometimentos &&
                requisicaoSemSaldoASerRateado &&
                usuarioAtualSolicitante
            )
        }
    },
    watch: {
        requisicao() {
            this.desabilitarBotaoEnviarRequisicao = this.deveDesabilitarBotaoEnviarRequisicao()
        }
    },
    computed: {}
}
</script>
